import React, { useState } from "react"; 
import BasePage from "../../../Components/Base/BasePage";
import RotogramaViagemComponent from "./RotogramaViagemComponent";

const RotogramaViagemPage = (props: any) => {
    const [loading, setLoading] = useState(true);
    
    function loadingCallBack(loading: boolean) {
        setLoading(loading);
    }

    return (
        <BasePage loading={loading}>
            <RotogramaViagemComponent loadingCallBack={loadingCallBack} />
        </BasePage>
    );
}

export default RotogramaViagemPage;

